// Section 17 and 18: Warmth policy. Equal / Households with children first / Elders first /
// Workers first, resolved per household (beds, not people). The preview counts the households
// kept warm first. Default: config.policies.defaults.warmth.
import type { Config } from '../../config';
import { noChangeCost, noProblem } from '../../core/content-helpers';
import { sortedValues } from '../../core/sorted';
import { definePolicy, noModifiers } from '../../core/registry';

export function warmth(config: Config) {
  return definePolicy({
    id: 'warmth',
    label: 'Warmth',
    section: 'S18',
    group: 'rations',
    options: ['equal', 'children-first', 'elders-first', 'workers-first'],
    default: config.policies.defaults.warmth,
    modifierTargets: [],
    modifiers: noModifiers,
    changeCost: noChangeCost,
    affects(ctx, option) {
      const first = new Set<string>();
      for (const id of config.rationing.warmthPlans[option].order) {
        if (id === 'everyone-else') continue;
        for (const p of ctx.registry.priorityGroups[id].members(ctx)) first.add(p);
      }
      const households = sortedValues(ctx.state.households).filter((h) => h.memberIds.length > 0);
      const warmFirst = households.filter((h) => h.memberIds.some((id) => first.has(id))).length;
      return [
        {
          key: `policy.warmth.${option}`,
          params: { count: warmFirst, households: households.length },
        },
      ];
    },
    validate: noProblem,
  });
}
